import { createSlice } from '@reduxjs/toolkit';
const initialState = null;
const parentPageHSAnalyticsInfoSlice = createSlice({
  name: 'parentPageHSAnalyticsInfo',
  initialState: initialState,
  reducers: {
    setParentHubspotUtk(state, action) {
      return Object.assign({}, state || {}, {
        parentHubspotUtk: action.payload
      });
    }
  }
});
export const {
  setParentHubspotUtk
} = parentPageHSAnalyticsInfoSlice.actions;
export default parentPageHSAnalyticsInfoSlice.reducer;